<template>
<div class="popup" v-cloak v-show="taskProgressShow">
    <div class="content" id="taskProgress">
        <div class="close-popup-other" @click="close()"></div>
        <div class="progress-title" v-if="!isVip()">
            <div class="progress-title-1">
                {{$t('language.cloudBackup.maximunBack')}}
            </div>
            <div class="progress-title-2">
                {{$t('language.popup.taskProgressPopup.title2')}}
            </div>
        </div>
        <div class="progress-title" v-else>
            <div class="progress-title-1">
                {{$t('language.popup.taskProgressPopup.title1')}}
            </div>
        </div>
        <div class="progress-list">
            <div class="progress-list-item" v-for="(item) in taskProgress" :key="item.id">
                <div>
                    <!-- 图标 -->
                    <div class="small-file" :class="item.icon"></div>
                </div>
                <div class="progres-item">
                    <div class="progres-item-title">
                        <div class="progres-name">
                            {{item.name}}
                        </div>
                        <!-- 进度 -->
                        <div class="progres-percentage">
                            <div v-if="!isVip()">
                                <img src="~@/assets/images/task-icon/progress_lock.svg" v-if="item.rate==-1">
                                <span class="" v-else>{{item.rate<100?item.rate:100}}%</span>
                            </div>
                            <div v-else>
                                <span class="" v-if="item.rate&&item.rate>=0">{{item.rate<100?item.rate:100}}%</span>
                                <span class="" v-else>0%</span>
                            </div>
                        </div>
                    </div>
                    <!-- 进度条 -->
                    <el-progress v-if="taskProgressShow&&(item.rate!=-1||isVip())" :percentage="item.rate>=0?item.rate:0" color="#5562B4" :show-text="false" :text-inside="true"></el-progress>
                </div>
            </div>
        </div>
        <div class="progress-btns">
            <button v-if="!isVip()">
                {{$t('language.common.upgradeNow')}}
                <div class="progress-btn-tip">{{$t('language.popup.taskProgressPopup.btnTip')}}</div>
            </button>
            <button v-else @click="close()" style="background:#3250c9;">
                {{$t('language.common.ok')}}
            </button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    name: "taskProgress",
    data: function () {
        return {
            taskProgressShow: false,
            taskProgress: [],
            taskId: null,//需要检测的任务id
            refreshTimer: null,//检测刷新列表定时器
            REFRESH_INTERVAL: 3000,//检测刷新列表间隔时间
        }
    },
    mounted() {
    },
    beforeDestroy() {
        //移除定时器
        console.log("beforeDestroy","refreshTimer");
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }
    },
    watch: {
    },
    methods: {
        initPage(id) {
            this.taskProgressShow = true;
            this.taskId = id;
            console.log("taskProgressShow",true);
            console.log("taskProgressShow",this.refreshTimer);
            if(!this.refreshTimer) {
                //启动时如果没有定时器则启动
                this.startInterval();
                this.refreshTimer = setInterval(async () => {
                    console.log("startInterval");
                    await this.startInterval();
                }, this.REFRESH_INTERVAL); // 每3秒执行一次
            }
        },
        //开启页面后，实时刷新进度信息
        async startInterval() {
            let progress = this.$store.getters.getTaskProgress[this.taskId];
            console.log('progress实时进度',this.taskProgress);
            console.log('progress实时进度',progress);
            if(this.taskProgress.length<1 && !progress) {
                //如果之前有进度，但是现在没有了，则判断任务结束，需要关闭弹窗
                this.close();
            }else if(this.taskId && progress) {
                //如果存在对应进度信息
                this.initProgress(progress);
            }else {
                this.taskProgress = [];
            }
            console.log("endTime",new Date())
        },
        initProgress(progress) {
            if(progress) {
                let proList;
                this.taskProgress = [];
                var tempProgress = [];
                var lockProgress = [];
                var that = this;
                if(progress.type == 6) {
                    proList = progress.details.stateSet;
                    if(proList){
                        proList.forEach(item => {
                            let rate = 0;
                            if(item.readedBytes&&item.totalBytes) {
                                rate = (item.readedBytes/item.totalBytes).toFixed(2)*100;
                            }
                            var progres = {
                                id: item.id,
                                name: item.itemName,
                                rate: rate?rate:0
                            }
                            //获取图标
                            progres.icon = that.matchfileType(progres.name);
                             if(progres.rate>=0) {
                                tempProgress.push(progres);
                            }else {
                                lockProgress.push(progres);
                            }
                        });
                    }
                }else if(progress.type == 2) {
                    if(progress.taskingFile) {
                        let taskingFile = progress.taskingFile;
                        var progres = {
                            id: item.id,
                            name: taskingFile.filename,
                        }
                        if(taskingFile.completedCount) {
                            progres.rate = taskingFile.totalCount/taskingFile.completedCount;
                        }
                        progres.icon = that.matchfileType(progres.name);
                        if(progres.rate>=0) {
                            tempProgress.push(progres);
                        }else {
                            lockProgress.push(progres);
                        }
                    }
                }else {
                    proList = progress.details.entities;
                    if(proList){
                        proList.forEach(item => {
                            var progres = {
                                id: item.id,
                                name: item.filename,
                                rate: item.rate
                            }
                            //获取图标
                            progres.icon = that.matchfileType(progres.name);
                            if(progres.rate>=0) {
                                tempProgress.push(progres);
                            }else {
                                lockProgress.push(progres);
                            }
                        });
                    }
                }

                this.taskProgress = tempProgress.concat(lockProgress).slice(0, 10);
            }else {
                this.taskProgress = [];
            }
        },
        isVip() {
            let flag = commonUtils.isVip();
            return flag;
        },
        matchfileType(fileName) {
            return commonUtils.matchfileTypes(fileName);
        },
        close() {
            console.log("closeProgressPopup")
            this.taskProgressShow = false;
            //如果是关闭，则置空
            this.taskId = null;
            this.taskProgress = [];
            if(this.refreshTimer) {
                //关闭时如果有定时器则关闭
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
                console.log("close",this.refreshTimer);
            }
        }
    }
}
</script>

<style scoped>
.popup {
    font-family: Arial;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
}
#taskProgress {
    width: 820px;
    /*no*/
    height: 786px;
    /*no*/
    background: linear-gradient(to bottom,#F2F7FE 0%,#F2F7FE 300px,#ffffff 301px,#ffffff 100%);
}

.progress-title {
    margin: 60px 70px 28px 70px;/*no*/
    color: #333333;
}

.progress-title-2 {
    font-size: 20px;
    /*no*/
    font-weight: bold;
}

.progres-name {
    width: calc(100% - 50px);/*no*/
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.progress-list {
    display: flex;
    flex-direction: column;
    padding: 10px;
    /*no*/
    box-sizing: border-box;
    border: 1px solid #D3DCF0;
    /*no*/
    border-radius: 12px;
    /*no*/
    width: 700px;
    /*no*/
    height: 540px;
    /*no*/
    margin: auto;
    background: #ffffff;
}

.progres-item {
    width: calc(100% - 48px);/*no*/
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.progress-list-item {
    display: flex;
}

.small-file {
    margin: 10px;
    /*no*/
}

.progress-btns {
    margin: 30px auto;
    /*no*/
    text-align: center;
}

.progress-btns button {
    position: relative;
    min-width: 240px;
    /*no*/
    height: 40px;
    /*no*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    /*no*/
    margin: auto;
    padding: 6px 12px;
    /*no*/
    gap: 6px;
    /*no*/
    text-align: center;
    background: linear-gradient(167deg, #FFA133 10%, #F58427 55%);
}

.progress-btns button .progress-btn-tip{
    position: absolute;
    left: 197px;
    /*no*/
    top: -10px;
    /*no*/
    width: max-content;
    min-width: 72px;
    /*no*/
    height: 16px;
    /*no*/
    border-radius: 8px 8px 8px 0px;
    /*no*/
    opacity: 1;
    display: flex;
    flex-direction: column;
    padding: 5px 10px;
    /*no*/
    gap: 10px;
    /*no*/
    background: #5562B4;
    font-size: 12px;
    /*no*/
}

.progres-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
}

.close-popup-other {
    position: absolute;
    top: 20px;
    /*no*/
    right: 20px;
    /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_progress_popup.vue